<template>
  <audio ref="audioPlayer" :src="src"></audio>
</template>

<script>
// @group Audio
// Reactive audio player
export default {
  name: "AudioPlayer",
  props: {
    // Audio source
    src: {
      type: String,
      default: null
    },
    // Play/pause setter
    play: {
      type: Boolean,
      required: true
    },
    // Time (in seconds) setter
    time: {
      type: Number,
      default: 0
    },
    // Volume setter (in range 0-1)
    volume: {
      Number,
      default: 1,
      validator(val) {
        return val >= 0 && val <= 1;
      }
    }
  },
  data() {
    return {
      audioPlayer: null
    };
  },
  watch: {
    // @vuese
    // Synchronize player play/paused status
    play(val) {
      if (val) {
        this.audioPlayer.play();
      } else {
        this.audioPlayer.pause();
      }
    },
    // @vuese
    // Syncronize player time
    time(time) {
      this.audioPlayer.currentTime = time;
    },
    // @vuese
    // Syncronize player volume
    volume(vol) {
      this.audioPlayer.volume = vol;
    }
  },
  mounted() {
    this.$nextTick(this.initPlayer);
  },
  methods: {
    // @vuese
    // Init audio player variable and add listeners for it
    initPlayer() {
      this.audioPlayer = this.$refs.audioPlayer;
      this.audioPlayer.addEventListener("timeupdate", () => {
        this.$emit("timeupdate", this.audioPlayer.currentTime);
      });
    }
  }
};
</script>

<style></style>
